<template>
  <span class="indicator" :style="{ color }">
    <span v-if="subtotal < MINIMUM_DELIVERY_AMOUNT">
      (${{ (MINIMUM_DELIVERY_AMOUNT - subtotal).toFixed(2) }} from delivery)
    </span>
    <span v-else>(View delivery rules)</span>
    &nbsp;<i @click="$emit('clickInfo')" class="el-icon-info"></i>
  </span>
</template>

<script>
import { MINIMUM_DELIVERY_AMOUNT } from "@/utils/order";

export default {
  name: "delivery-indicator",
  data() {
    return {
      MINIMUM_DELIVERY_AMOUNT,
      display: {
        dialog: {
          isVisible: false,
        },
      },
    };
  },
  props: {
    subtotal: Number,
    color: String,
  },
};
</script>

<style scoped>
.indicator {
  font-size: 0.8rem;
}
</style>